import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare } from "@fortawesome/pro-solid-svg-icons";

import "./index.scss";

const Agreements = ({ agreements }) => {
  if (!agreements?.length) return null;

  return (
    <div className="desk-comm-agreements">
      {agreements.map((item, index) => (
        <div className="desk-comm-agreement" key={index}>
          <FontAwesomeIcon icon={faCheckSquare} className="i-green" />
          <span className="desk-comm-agreement-name">{item.name}</span>
        </div>
      ))}
    </div>
  );
};

export default Agreements;
